import { Box } from "@mui/material";
import Sidebar from "./components/aside";
import { useState } from "react";
import NoticiasBody from "./components/noticias";
import MeuPlanoBody from "./components/meuPlano";
import FinanceiroBody from "./components/financeiro";
import AtendimentoBody from "./components/atendimento";
import PoliticaBody from "./components/politica";

export type IDrawerItem = "noticias" | "meu-plano" | "financeiro" | "atendimento" | "politica" | "sair";

const BeneficiarioPage = () => {

    const [currentPage, setCurrentPage] = useState<IDrawerItem>("noticias");

    const renderBody = () => {
         switch (currentPage) {
            case "noticias":
                return <NoticiasBody/>
            case "meu-plano":
                return <MeuPlanoBody/>
            case "financeiro":
                return <FinanceiroBody/>
            case "atendimento":
                return <AtendimentoBody/>
            case "politica":
                return <PoliticaBody/>
            case "sair":
                
                break;
        
            default:
                break;
        }
    }
    return <Box sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", paddingLeft: "18vw"}}>
        <Sidebar currentPage={currentPage} setCurrentPage={setCurrentPage}/>
        {renderBody()}
    </Box>
}
export default BeneficiarioPage;